import { last } from "rxjs/operators";

export const Role = {
    Admin: 'A',
    Manager: 'M',
    Employee: 'E',
    Customer: 'C',
    User: 'User'    
}


export function getUserRoleFromStoreId(storeId, userId) {
    
    if(storeId){
        if(storeId.indexOf(window.TRYBOOK.storeId + "EM") > -1){
            return Role.Manager;
        }

        if(storeId.indexOf(window.TRYBOOK.storeId + "E") > -1){
            return Role.Employee;
        }

        if(window.TRYBOOK.employees.find(emp => emp.userId === userId)){
            return Role.Employee;
        }

        //get the last letter of the storeId
        // const lastLetter = storeId.charAt(storeId.length - 1);
        // switch(lastLetter){
        //     case "M":
        //         return Role.Manager;
        //     case "E":
        //         return Role.Employee;
        //     default:
        //         return Role.Customer;
        // }
    }
    return Role.Customer;
}